const location_map = new Map();

export const exportToCSVForAllScans = async (scanResults, user, crop) => {
    const csvRows = [];
    const rows = [];
    const columnsArray = [];

    for (const scanResult of scanResults) {
        const isM6 = scanResult?.machine_code === 'M6';

        const columns = [
            'User Name',
            'Login ID',
            'Email/Phone Number',
            'ScanID',
            'Total Scans',
            'Grain Type',
            'Machine',
            'Date',
            'Phone/Device Name',
            'Location',
            'CV Variety Name',
            'Scan Updated Date'
        ];

        const dist_avg_indexes = scanResult?.dist_avg_indexes;
        Object.keys(dist_avg_indexes || {}).forEach((key) => {
            columns.push(key);
        });
        const user_metadata = scanResult?.user_metadata;
        Object.keys(user_metadata || {}).forEach((key) => {
            columns.push(key);
        });

        if (isM6) {
            columns.push("Total Count");
            columns.push("Weight(gm)");
            columns.push("Moisture(%)");
            columns.push("Thousand Corn Weight (gm)"); 
        } else {
            columns.push("Total Kernel Count");
            columns.push("Total Kernel Count %");
            columns.push("Total Kernel Weight (gm)");
            columns.push("Total Kernel Weight (%)");

            scanResult?.kernel_details?.classes?.forEach((key) => {

                const translations = scanResult?.kernel_details?.beautify?.translations;
                const encodings = scanResult?.processed_image?.encodings;

                const kernelName = translations?.kernel_counts?.[key] ?? key;
                const encoding = encodings?.[key] ?? "";

                const sanitizedKernelName = kernelName
                    ? String(kernelName).replace(/,/g, "-")
                    : "";

                columns.push(`${sanitizedKernelName} (${encoding}) Count`);
                columns.push(`${sanitizedKernelName} (${encoding}) Count %`);

                columns.push(`${sanitizedKernelName} (${encoding}) Weight`);
                columns.push(`${sanitizedKernelName} (${encoding}) Weight %`);

                if (scanResult?.kernel_details?.grading) {
                    if (scanResult?.kernel_details?.max_limit) {
                        columns.push(`${sanitizedKernelName} (${encoding}) % By`);
                        columns.push(`${sanitizedKernelName} (${encoding}) Maximum Limit`);
                    } else {
                        columns.push(`${sanitizedKernelName} (${encoding}) Grade`);
                        columns.push(`${sanitizedKernelName} (${encoding}) % By`);
                        columns.push(`${sanitizedKernelName} (${encoding}) Range 1`);
                        columns.push(`${sanitizedKernelName} (${encoding}) Range 2`);
                        columns.push(`${sanitizedKernelName} (${encoding}) Range 3`);
                    }
                }

                columns.push(`${sanitizedKernelName} (${encoding}) Area (mm2)`);
                columns.push(`${sanitizedKernelName} (${encoding}) Length (mm)`);
            });

            columns.push("Moisture %");
            columns.push("Moisture Weight");
            if (scanResult?.kernel_details?.grading) {
                if (scanResult?.kernel_details?.max_limit) {
                    columns.push("Moisture % By");
                    columns.push("Moisture Maximum Limit");
                } else {
                    columns.push("Moisture Grade");
                    columns.push("Moisture % By");
                    columns.push("Moisture Range1");
                    columns.push("Moisture Range2");
                    columns.push("Moisture Range3");
                }
            }

            columns.push("Thousand Grain Weight (TGW) (gm)"); 
        }

        const resultArray = [];
        Object.values(dist_avg_indexes).forEach((value) => {
            resultArray.push(value);
        });
        Object.values(user_metadata).forEach((value) => {
            resultArray.push(value);
        });
        const addressData = scanResult?.address || "Unknown";
        const row = [
            `${user?.first_name} ${user?.last_name}`,
            user?.user_name,
            user?.email && user?.phone_number
                ? `${user?.email} / ${user?.phone_number}`
                : user?.email || user?.phone_number,
            scanResult?.scan_id,
            scanResult?.scan_count,
            `${scanResult?.crop_name} - ${scanResult?.variety_name}`,
            `${scanResult?.machine_name} (${scanResult?.machine_code})`,
            scanResult?.created_at,
            `${scanResult?.device_info}`,
            `"${addressData}"`,
            scanResult?.cv_variety_name && scanResult.cv_variety_name !== ""
                ? scanResult.cv_variety_name
                : "-",
            scanResult?.scan_updated_date || "-",
            ...resultArray,

        ]

        if (isM6) {
            const totalCountM6 = scanResult?.kernel_details?.total_kernel_count ?? 0;
            row.push(totalCountM6);
            const weightVal = parseFloat(scanResult?.weight_value) > 0
                ? parseFloat(scanResult?.weight_value)
                : parseFloat(scanResult?.kernel_details?.total_kernel_weight || 0);
            row.push(Number(weightVal));
            row.push(scanResult?.moisture_value ? Number(scanResult.moisture_value) : 0);

            const tcwM6 = totalCountM6 > 0 && weightVal > 0
                ? ((weightVal * 1000) / totalCountM6).toFixed(2)
                : "NA";
            row.push(tcwM6);
        } else {
            if (scanResult?.kernel_details?.total_kernel_count > 0) {
                row.push(scanResult?.kernel_details?.total_kernel_count);
                row.push("100%");
            } else {
                row.push("NA");
                row.push("NA");
            }

            if (parseFloat(scanResult?.kernel_details?.total_kernel_weight) > 0) {
                row.push(parseFloat(scanResult?.weight_value) > 0 ? parseFloat(scanResult?.weight_value).toFixed(3) : parseFloat(scanResult?.kernel_details?.total_kernel_weight).toFixed(3))
                row.push("100%");
            } else {
                row.push("NA");
                row.push("NA");
            }

            scanResult?.kernel_details?.classes?.forEach((key, index) => {
                if (scanResult?.kernel_details?.total_kernel_count > 0) {
                    row.push(Number(scanResult?.kernel_details?.kernel_counts[key]));
                    row.push(` ${Number(scanResult?.kernel_details?.kernel_counts[key] / scanResult?.kernel_details?.total_kernel_count * 100).toFixed(2)}%`);
                } else {
                    row.push("NA");
                    row.push("NA");
                }

                if (parseFloat(scanResult?.kernel_details?.total_kernel_weight) > 0) {
                    let weightKey = scanResult?.kernel_details?.kernel_weights ? scanResult?.kernel_details?.kernel_weights : scanResult?.kernel_details?.kernel_weight;
                    if (parseFloat(scanResult?.weight_value) === 0) {
                        row.push(Number(weightKey[key]).toFixed(3))
                        row.push(Number(weightKey[key] / scanResult?.kernel_details?.total_kernel_weight * 100).toFixed(2) + "%")
                    } else {
                        const weightedPercentageOfTotal = Number(weightKey[key] / scanResult?.kernel_details?.total_kernel_weight * 100)
                        const finalWeightFromSampleWeight = Number(weightedPercentageOfTotal * parseFloat(scanResult?.weight_value ? scanResult?.weight_value : scanResult?.kernel_details?.total_kernel_weight) / 100)
                        row.push(Number(finalWeightFromSampleWeight).toFixed(3))
                        row.push(Number(weightKey[key] / scanResult?.kernel_details?.total_kernel_weight * 100).toFixed(2) + "%")
                    }
                } else {
                    row.push("NA");
                    row.push("NA");
                }

                if (scanResult?.kernel_details?.grading) {
                    let classGrading;
                    let rangeValues;

                    if (scanResult?.kernel_details?.max_limit) {
                        classGrading = scanResult?.kernel_details?.grading[key];
                        rangeValues = classGrading?.weightRange || classGrading?.countRange || ["NA"];

                        if (classGrading?.weightRange) {
                            row.push('Weight');
                        } else if (classGrading?.countRange) {
                            row.push('Count');
                        } else {
                            row.push('NA');
                        }

                        row.push(rangeValues[0]);

                    } else {
                        const value = scanResult?.kernel_details?.class_ranges[key];
                        row.push(value > 0 ? value : 'NA');

                        classGrading = scanResult?.kernel_details?.grading[key];
                        rangeValues = classGrading?.weightRange || classGrading?.countRange || ["NA", "NA", "NA"];

                        if (classGrading?.weightRange) {
                            row.push('Weight');
                        } else if (classGrading?.countRange) {
                            row.push('Count');
                        } else {
                            row.push('NA');
                        }

                        row.push(rangeValues[0]);
                        row.push(rangeValues[1]);
                        row.push(rangeValues[2]);
                    }
                }

                if (scanResult?.kernel_details?.consider_area) {
                    const areaValue = scanResult.kernel_details.areas[key];
                    if (areaValue !== "NaN" && !isNaN(Number(areaValue))) {
                        row.push(Number(areaValue).toFixed(2));
                    } else {
                        row.push("-");
                    }
                } else {
                    row.push("-");
                }

                if (scanResult?.kernel_details?.consider_length) {
                    const lengthValue = scanResult.kernel_details.kernel_lengths[key];
                    if (lengthValue !== "NaN" && !isNaN(Number(lengthValue))) {
                        row.push(Number(lengthValue).toFixed(2));
                    } else {
                        row.push("-");
                    }
                } else {
                    row.push("-");
                }
            });

            if (scanResult?.moisture_value) {
                row.push(scanResult?.moisture_value ? scanResult?.moisture_value + "%" : 'NA');
            } else {
                row.push('NA')
            }

            if (scanResult?.moisture_weight) {
                row.push(scanResult?.moisture_weight ? scanResult?.moisture_weight + "gm" : 'NA');
            } else {
                row.push('NA')
            }

            if (scanResult?.kernel_details?.grading) {
                let moistureGrading = scanResult?.kernel_details?.grading?.moisture;
                let rangeValues;

                if (scanResult?.kernel_details?.max_limit) {
                    rangeValues = moistureGrading?.weightRange || moistureGrading?.countRange || ["NA"];
                    row.push(moistureGrading?.weightRange ? 'Weight' : 'Count');
                    row.push(rangeValues[0] || "NA");
                } else {
                    rangeValues = moistureGrading?.weightRange || moistureGrading?.countRange || ["NA", "NA", "NA"];
                    row.push(scanResult?.kernel_details?.moisture_range);
                    row.push(moistureGrading?.weightRange ? 'Weight' : 'Count');
                    row.push(rangeValues[0]);
                    row.push(rangeValues[1]);
                    row.push(rangeValues[2]);
                }
            }

            const totalCount = scanResult?.kernel_details?.total_kernel_count;
            const weightForTCW = parseFloat(scanResult?.weight_value) > 0
                ? parseFloat(scanResult?.weight_value)
                : parseFloat(scanResult?.kernel_details?.total_kernel_weight || 0);
            const tcw = totalCount > 0 && weightForTCW > 0
                ? ((weightForTCW * 1000) / totalCount).toFixed(2)
                : "NA";
            row.push(tcw);
        }

        if (!isM6) {
            const distribution = scanResult?.kernel_details?.range_distributions?.labels;
            if (distribution) {
                const { headers: matrixHeaders, values: matrixValues } = flattenMatrixToRow(scanResult?.kernel_details?.range_distributions);
                columns.push(...matrixHeaders);
                row.push(...matrixValues);
            }
        }

        rows.push(row)
        columnsArray.push(columns);
    }

    const maxColumns = columnsArray.reduce(
        (max, current) => Math.max(max, current.length),
        0
    );
    const headers = columnsArray.find((col) => col.length === maxColumns);

    const table = {
        title: "",
        subtitle: "",
        headers: headers,
        rows: rows
    };
    const headerRow = table.headers.map((column) => column);
    csvRows.push(headerRow.join(','));
    table.rows.forEach((row) => {
        const csvRow = row.map((cell) => {
            const cellValue = cell?.toString().replace(/"/g, '""');
            return `"${cellValue}"`;
        });
        csvRows.push(csvRow.join(','));
    });
    const csvData = csvRows.join('\n');
    const link = document.createElement('a');
    link.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csvData);
    link.target = '_blank';
    link.download = `${crop}.csv`;
    link.click();
    location_map.clear()
};

function flattenMatrixToRow(matrixData) {
    const distributions = matrixData.distributions;
    const widths = matrixData.labels.widths;
    const heights = matrixData.labels.heights;

    const headers = [];
    const values = [];

    for (let w = 0; w < widths.length; w++) {
        for (let h = 0; h < heights.length; h++) {
            const widthLabel = widths[w];
            const heightLabel = heights[h];
            headers.push(`W${widthLabel} H${heightLabel}`);
            values.push(distributions[w]?.[h] ?? 0);
        }
    }

    return { headers, values };
}

export const onGetFormatedDateRange = (selected_option) => {
    // Compute the date range based on the selected option
    const today = new Date();
    let startDate = null;
    let endDate = today;

    if (selected_option === 'all') {
        startDate = new Date(2022, 0, 1); // January 1, 2022
    } else if (selected_option === 'today') {
        startDate = new Date(today);
        startDate.setHours(0, 0, 0, 0);
        endDate = new Date(today);
        endDate.setHours(23, 59, 59, 999);
    } else if (selected_option === 'this_week') {
        const today = new Date();
        const currentDay = today.getDay();
        const lastWeekStart = new Date(today);
        lastWeekStart.setDate(today.getDate() - currentDay);
        startDate = lastWeekStart;
        endDate = today;
    } else if (selected_option === 'this_month') {
        const today = new Date();
        const currentMonthStart = new Date(today.getFullYear(), today.getMonth(), 1);
        startDate = currentMonthStart;
        endDate = today
    } else if (selected_option === 'this_year') {
        const today = new Date();
        startDate = new Date(today.getFullYear(), 0, 1);
        endDate = today;
    }
    // Format dates to the specified form
    const formattedStartDate = startDate.toISOString();
    const formattedEndDate = endDate.toISOString();
    return { start_date: formattedStartDate, end_date: formattedEndDate };
}

export const getMonthAbbreviation = (month_number) => {
    switch (month_number) {
        case '01':
            return 'Jan';
        case '02':
            return 'Feb';
        case '03':
            return 'Mar';
        case '04':
            return 'Apr';
        case '05':
            return 'May';
        case '06':
            return 'Jun';
        case '07':
            return 'Jul';
        case '08':
            return 'Aug';
        case '09':
            return 'Sep';
        case '10':
            return 'Oct';
        case '11':
            return 'Nov';
        case '12':
            return 'Dec';
        default:
            return 'Invalid Month';
    }
}